import { useState } from "react";
import { twMerge } from "tailwind-merge";

interface FieldProps {
  id: string;
  name: string;
  type: "checkboxed" | "radio" | "inputText"|"scale"|"phone";
  isRequired?: boolean;
 // validation?:()=> Boolean;
  labelEn: string;
  labelFr: string;
  placeHolder?:string|null;
  options?: OptionProps[] | null;
  className?:string
}

interface OptionProps {
  id: string|number;
  name: string;
  labelEn: string;
  labelFr: string;
}

const useField = ({ id, name, type, labelEn, labelFr,isRequired=false, options = null,placeHolder=null,className="" }: FieldProps) => {
  const [value, setValue] = useState<string | string[] | null>(type === "checkboxed" ? [] : "");
  const [error, setError] = useState< string | null>();
  const [scale, setScale] = useState<string | null>("");
  const [isValid,setIsValid] = useState<boolean>(true);

  const validate = () => {
    let v = true;
    if (type === "checkboxed") {
      if (Array.isArray(value) && value.length === 0) {
        setError("Please select at least one option");
        v = false;
      } else {
        setError(null);
      }
    }else if (type === "phone") {
      // Vérifie que le numéro commence par 6 et contient exactement 9 chiffres
      if (!/^6\d{8}$/.test(value as string)) {
        setError("Le numéro doit commencer par 6 et contenir exactement 9 chiffres.");
        v = false;
      } else {
        setError(null);
      }
    }else{
     if (value === "") { setError("This field is required");v=false; }else{ setError(null)};

    }
    setIsValid(v);
    return v;
  }
  const onClear = () => {
    if (type=== "checkboxed") {
      setValue([]);
      
    }else if(type === "scale"){
      setScale(null);
      setValue("");
    }else{
      setValue("");
    }
    setError(null);
    setIsValid(true);
  }

 // const validate = () => {};
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "checkboxed") {
      const { checked, value: optionValue } = e.target;
      setValue((prevValue) => {
        const currentValue = Array.isArray(prevValue) ? prevValue : [];
        return checked
          ? [...currentValue, optionValue]
          : currentValue.filter((val) => val !== optionValue);
      });
    } else if (type === "radio") {
      setValue(e.target.value);
    } else if (type ==="phone") {
      
      const phoneValue = e.target.value;
      // Vérifie que le numéro contient uniquement des chiffres
      if (/^\d*$/.test(phoneValue)) {
        setValue(phoneValue);
      }
    }else {
        setValue(e.target.value);
      }
  };
  const field = (
    <div key={id} className="flex flex-col gap-y-5  font-[500] text-[24px]">
    <div className="flex items-start gap-x-[6px]">
      <span className=''>{id}. </span>
      <span className=" ">
        <span className='text-[#25AAE1]'>{labelFr}</span>
        <span>  {labelEn}</span> <span className='text-red-500'>*</span>
      </span>
    </div>
    <div className="flex py-2">
    {type === "inputText" && (
        <input
          id={id}
          required={isRequired}
          name={name}
          type="text"
          value={value as string}
          onChange={handleChange}
          className={"w-full h-[70px] px-4 rounded-[10px] outline-none border-none bg-[#FFFFFF]"+className}
          placeholder={placeHolder??"Entrez votre réponse"}
        />
      )}
        {type === "phone" && (
        <input
          id={id}
          name={name}
          required={isRequired}
          type="phone"
          value={value as string}
          maxLength={9}
          minLength={9}
          onChange={handleChange}
          className={"w-full h-[70px] px-4 rounded-[10px] outline-none border-none bg-[#FFFFFF]"+className}
          placeholder={placeHolder??"Entrez votre réponse"}
        />
      )}
      {type === "scale" && (
         <div className="flex w-full justify-between">
         {[0,1,2,3,4,5,6,7,8,9].map((item)=>(
           <div onClick={()=>{setScale(item.toString()); setValue(item.toString()); }}  className={twMerge("flex items-center justify-center w-[120px]  h-[70px] bg-[#FFFFFF] rounded-[10px] cursor-pointer",scale === item.toString()&& 'bg-[#25AAE1]')} key={item}>
             <span  className={twMerge('text-[24px] text-[#B7B7B7] font-[500]',scale === item.toString()&&  'text-white')}>{item}</span>
           </div>
         ))}
       </div>
      )}
      {type === "checkboxed" && options && (
        <div className="flex flex-col gap-2">
          {options.map((option) => (
            <label key={option.id} className="flex items-center gap-2">
              <input
                type="checkbox"
                required={isRequired}
                name={name}
                value={option.name}
                checked={(value as string[]).includes(option.name)}
                onChange={handleChange}
              />
              <span>
                {option.labelFr} / {option.labelEn}
              </span>
            </label>
          ))}
        </div>
      )}
      {type === "radio" && options && (
          <div key={id + name + "radio"}  className="flex flex-col gap-y-3">
          {options.map((option,index)=>(
            <label key={option.id + option.name}  htmlFor={option.name + id} className='flex gap-x-3 items-center' >
               <input
                required={isRequired}
                 id={option.name+id}
                 type="radio"
                 name={name}
                 value={option.name}
                 checked={value === option.name}
                 onChange={handleChange}
             />
                <span > <span className='text-[#25AAE1]'>{option.labelFr} /</span>  <span>{option.labelEn}</span> </span>
            </label>
            
          ))}
        </div>
      )}
    </div>
   {!isValid &&  <span className='text-red-600 '>{error}</span>}
  </div>

  );

  return { field, value, setValue,error,setError,isValid,setIsValid,validate ,onClear};
};

export default useField;